module.exports = __webpack_public_path__ + "img/uranium-ammo.b937d98f.png";